


export const COUPON_DISCOUNT_TYPE_FIXED = 'fixed';
export const COUPON_DISCOUNT_TYPE_PERCENTAGE = 'percentage';
